/* eslint-disable max-len */
import { createImmutableSelector } from 'utils/reselect'
import { List as ImmutableList, Map as ImmutableMap, Set as ImmutableSet } from 'immutable'
import { ensureDistributionListShape } from 'utils/contact_management'
import { getAllStaticLanguages } from './statics'

// DATA
const getData = state => state.contactManagement.get('data')
const getCmAllStaticLanguages = state => (state.statics ? getAllStaticLanguages(state) || ImmutableList() : ImmutableList())

export const getCmDaContacts = state => getData(state).get('contacts')
export const getCmDaContactsFilterIds = state => getData(state).get('contactsFilterIds')
export const getCmContactIdentityIds = state => getCmDaContacts(state).map(c => c.get('identityId')).toSet().filter(id => id)
export const getCmDaContactsLoadedCount = state => getCmDaContacts(state).size
export const getCmDaContactsTotalCount = state => getData(state).get('contactsTotal')

export const getCmDaDistributionLists = state => getData(state).get('distributionLists')
export const getCmDaDistributionListsFilterIds = state => getData(state).get('distributionListsFilterIds')
export const getCmDaDistributionListsTotalCount = state => getData(state).get('distributionListsTotal')

export const getCmDaDetailPageContact = state => getData(state).getIn(['contactDetailsData', 'contact']) || ImmutableMap()
export const getCmDaDetailPageEmailEvents = state => getData(state).getIn(['contactDetailsData', 'emailEvents']) || ImmutableSet()
export const getCmDaDetailPageEarnedMedia = state => getData(state).getIn(['contactDetailsData', 'earnedMedia'])

export const getCmDaDistributionListDetailsData = state => getData(state).get('distributionListDetailsData')
export const getCmDaDistributionListDetailsSelectedContactsToRemove = state => getCmDaDistributionListDetailsData(state).get('selectedContactsToRemove')
export const getCmDaContactsToRemove = state => getCmDaDistributionListDetailsData(state).get('contactsToRemove')
export const getCmDaDistributionListDetailsSelectedContactsToAdd = state => getCmDaDistributionListDetailsData(state).get('selectedContactsToAdd')

export const getCmDaSelectedDistributionLists = state => getData(state).get('selectedDistributionLists')
export const getCmDaDistributionListFormData = state => getData(state).get('distributionListFormData')

export const getCmDaContactsSearchData = state => getData(state).get('contactsSearch')
export const getCmDaDistributionListsSearchData = state => getData(state).get('distributionListsSearch')

export const getCmDaRanking = state => getData(state).get('ranking')
export const getCmDaPerformance = state => getData(state).get('performance')

export const getCmDaSuggestedContactData = state => getData(state).get('suggestedContactData')

// UI
const getUi = state => state.contactManagement.get('ui')

export const getCmUiQuery = state => getUi(state).get('query')

export const getCmUiSelectedMainTab = state => getUi(state).get('selectedMainTab')
export const getCmUiSelectedListTab = state => getUi(state).get('selectedListTab')
export const getCmUiSelectedContactTab = state => getUi(state).get('selectedContactTab')

export const getCmUiDetailPageContactId = state => getUi(state).get('contactDetailsContactId')
export const getCmUiContactDetailsEditMode = state => getUi(state).get('contactDetailsEditMode')
export const getCmUiContactsPage = state => getUi(state).get('contactsPage')
export const getCmUiContactDetailErrorReport = state => getUi(state).get('contactDetailErrorReport')
export const getCmUiNewContactData = state => getUi(state).get('createContactUserInput') || ImmutableMap()
export const getCmUiCreatedContactIds = state => getUi(state).get('createdContactIds') || ImmutableSet()

export const getCmUiDistributionListToDelete = state => getUi(state).get('distributionListToDelete')
export const getCmUiDistributionListToUpdate = state => getUi(state).get('distributionListToUpdate')
export const getCmUiDistributionListDetailsListId = state => getUi(state).get('distributionListDetailsListId')
export const getCmUiReturnToList = state => getUi(state).get('returnToList')
export const getCmUiReturnToContact = state => getUi(state).get('returnToContact')

export const getCmUiDistributionListBulkDelete = state => getUi(state).get('distributionListBulkDelete')

// UI > RUNNING REQUESTS
export const getCmUiAddContactsToListRequestRunning = state => getUi(state).get('addContactsToListRequestRunning')
export const getCmUiDownloadFailedContactsRequestRunning = state => getUi(state).get('downloadFailedContactsRequestRunning')
export const getCmUiExportContactsRequestRunning = state => getUi(state).get('exportContactsRequestRunning')
export const getCmUiFetchContactRequestRunning = state => getUi(state).get('fetchContactRequestRunning')
export const getCmUiFetchEarnedMediaRequestRunning = state => getUi(state).get('fetchEarnedMediaRequestRunning')
export const getCmUiFetchEmailEventsRequestRunning = state => getUi(state).get('fetchEmailEventsRequestRunning')
export const getCmUiFetchMoreContactsRequestRunning = state => getUi(state).get('fetchMoreContactsRequestRunning')
export const getCmUiFetchMoreDistributionListsRequestRunning = state => getUi(state).get('fetchMoreDistributionListsRequestRunning')
export const getCmUiFindContactRequestRunning = state => getUi(state).get('findContactRequestRunning')
export const getCmUiFindDistributionListRequestRunning = state => getUi(state).get('findDistributionListRequestRunning')
export const getCmUiGlobalRequestRunning = state => getUi(state).get('requestRunning')
export const getCmUiImportRequestRunning = state => getUi(state).get('importRequestRunning')
export const getCmUiLoadMoreContactsRequestRunning = state => getUi(state).get('loadMoreContactsRequestRunning')
export const getCmUiRemoveContactsFromListRequestRunning = state => getUi(state).get('removeContactsFromListRequestRunning')
export const getCmUiRemoveContactsFromDistributionListsRequestRunning = state => getUi(state).get('removeContactsFromDistributionListsRequestRunning')
export const getCmUiReportContactErrorRequestRunning = state => getUi(state).get('reportErrorRequestRunning')
export const getCmUiSearchContactRequestRunning = state => getUi(state).get('searchContactsRequestRunning')
export const getCmUiSearchDistributionListsRequestRunning = state => getUi(state).get('searchDistributionListsRequestRunning')
export const getCmUiReplaceContactsRequestRunning = state => getUi(state).get('replaceContactsRequestRunning')

// UI > DIALOGS
export const getCmUiContactsRemoveFromListsDialogOpen = state => getUi(state).get('contactsRemoveFromListsDialogOpen')
export const getCmUiAddContactsDialogOpen = state => getUi(state).get('contactsAddDialogOpen')
export const getCmUiContactCreateDialogOpen = state => getUi(state).get('contactCreateDialogOpen')
export const getCmUiContactDetailsAddListDialogOpen = state => getUi(state).get('contactDetailsAddListDialogOpen')
export const getCmUiContactRemoveDialogOpen = state => getUi(state).get('contactRemoveDialogOpen')
export const getCmUiContactReportErrorDialogOpen = state => getUi(state).get('contactReportErrorDialogOpen')
export const getCmUiContactsDeleteDialogOpen = state => getUi(state).get('contactsDeleteDialogOpen')
export const getCmUiContactsExportDialogOpen = state => getUi(state).get('contactsExportDialogOpen')
export const getCmUiImportPageOpen = state => getUi(state).get('importPageOpen')
export const getCmUiDistributionListCreateDialogOpen = state => getUi(state).get('distributionListCreateDialogOpen')
export const getCmUiDistributionListDeleteDialogOpen = state => getUi(state).get('distributionListDeleteDialogOpen')
export const getCmUiDistributionListDetailsOpen = state => getUi(state).get('distributionListDetailsOpen')
export const getCmUiDistributionListExportUnavailableDialogOpen = state => getUi(state).get('distributionListExportUnavailableDialogOpen')
export const getCmUiDistributionListMergeDialogOpen = state => getUi(state).get('distributionListMergeDialogOpen')
export const getCmUiDistributionListUpdateDialogOpen = state => getUi(state).get('distributionListUpdateDialogOpen')
export const getCmUiContactSuggestDialogOpen = state => getUi(state).get('contactSuggestDialogOpen')

// CONTACTS DATA GRID
const getContactsDataGrid = state => state.contactManagement.get('contactsDataGrid')

export const getCmDgSettings = state => getContactsDataGrid(state).get('settings')
export const getCmDgPageSize = state => getCmDgSettings(state).getIn(['paginationModel', 'pageSize'])

// DISTRIBUTION LISTS DATA GRID
const getDistributionListsDataGrid = state => state.contactManagement.get('distributionListsDataGrid')

export const getCmDlDgSettings = state => getDistributionListsDataGrid(state).get('settings')

// IMPORTS
const getImports = state => state.contactManagement.get('imports')

export const getCmImActiveStep = state => getImports(state).get('activeStep')
export const getCmImUploadResult = state => getImports(state).get('uploadResult')
export const getCmImSetupResultColumns = state => getImports(state).getIn(['setupResult', 'columns'])
export const getCmImSelectedSheet = state => getImports(state).get('selectedSheet')
export const getCmImFirstRowHasHeaders = state => getImports(state).get('firstRowHasHeaders')
export const getCmImUseAiColumnMapping = state => getImports(state).get('useAiColumnMapping')
export const getCmImAutoAddToLists = state => getImports(state).get('autoAddToLists')
export const getCmImAutoCreateLists = state => getImports(state).get('autoCreateLists')
export const getCmImSelectedListIds = state => getImports(state).get('selectedListIds')
export const getCmImNewListNames = state => getImports(state).get('newListNames')
export const getCmImColumnMapping = state => getImports(state).get('columnMapping')
export const getCmImResult = state => getImports(state).get('importResult')
export const getCmImSelectedContactsToReplace = state => getImports(state).get('selectedContactsToReplace')

// CALCULATED

export const getCmUiRequestRunning = createImmutableSelector(
  getCmUiGlobalRequestRunning,
  getCmUiSearchContactRequestRunning,
  getCmUiImportRequestRunning,
  (global, contacts, importRequest) => {
    const requestRunning = global || contacts || importRequest

    return requestRunning
  }
)

export const getCmUiListsRequestRunning = createImmutableSelector(
  getCmUiGlobalRequestRunning,
  getCmUiSearchDistributionListsRequestRunning,
  getCmUiImportRequestRunning,
  (global, lists, importRequest) => {
    const requestRunning = global || lists || importRequest

    return requestRunning
  }
)

const hasSmartSearchQuery = query => !!(query || '').trim()

export const getCmUiContactsTabCount = createImmutableSelector(
  [getCmUiQuery, getCmDaContactsFilterIds, getCmDaContactsTotalCount],
  (query, contactFilterIds, contactsTotal) => (
    hasSmartSearchQuery(query) ? contactFilterIds.size : contactsTotal
  )
)

export const getCmUiDistributionListsTabCount = createImmutableSelector(
  [getCmUiQuery, getCmDaDistributionListsFilterIds, getCmDaDistributionListsTotalCount],
  (query, distributionListFilterIds, distributionListsTotal) => (
    hasSmartSearchQuery(query) ? distributionListFilterIds.size : distributionListsTotal
  )
)

export const getCmUiSearchRequestRunning = createImmutableSelector(
  getCmUiSearchContactRequestRunning,
  getCmUiSearchDistributionListsRequestRunning,
  (contacts, lists) => {
    const searchRunning = contacts || lists

    return searchRunning
  }
)

const enrichDistributionListContacts = (distributionList, contacts, staticLanguages) => {
  const contactsById = contacts.reduce(
    (contactsByIdMap, contact) => contactsByIdMap.set(String(contact.get('id')), contact),
    ImmutableMap()
  )

  return distributionList.update('contacts', ImmutableList(), listContacts => listContacts.map(listContact => {
    const canonicalContact = contactsById.get(String(listContact.get('id')))
    const contact = canonicalContact ? listContact.merge(canonicalContact) : listContact
    const languages = contact.get('languages', ImmutableList())

    if (!languages.isEmpty()) {
      return contact
    }

    const languageIds = contact.get('languageIds', ImmutableList()).toSet()

    if (languageIds.isEmpty()) {
      return contact
    }

    const resolvedLanguages = staticLanguages.filter(language => languageIds.includes(language.get('id')))

    return contact.set('languages', resolvedLanguages)
  }))
}

export const getCmDaDistributionListDetailsDataList = createImmutableSelector(
  [
    getCmDaDistributionLists,
    getCmDaContacts,
    getCmAllStaticLanguages,
    getCmDaDistributionListDetailsData,
    getCmUiDistributionListDetailsListId,
    getCmDaDetailPageContact
  ],
  (distributionLists, contacts, staticLanguages, detailsData, listId, detailContact) => {
    const fallbackList = detailsData.get('list')
    const selectedList = distributionLists.find(distributionList => distributionList.get('id') === listId)
    const matchingFallbackList = fallbackList?.get('id') === listId ? fallbackList : null
    const contactDistributionLists = detailContact.get('distributionLists') || ImmutableList()
    const detailContactList = contactDistributionLists.find(distributionList => distributionList.get('id') === listId)

    return enrichDistributionListContacts(
      ensureDistributionListShape(selectedList || matchingFallbackList || detailContactList),
      contacts,
      staticLanguages
    )
  }
)

export const getCmUiDistributionListToEdit = createImmutableSelector(
  [getCmDaDistributionLists, getCmUiDistributionListToUpdate],
  (distributionLists, selectedId) => distributionLists.find(list => list.get('id') === selectedId)
)
